var React = require('react');

function TitleBlockDownArrowSmall (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(68.352 -33.741)"},React.createElement("path",{"d":"m-66.147 36.242-2.0722-2.0722v-0.29607h0.29607l1.7761 1.7761 1.7761-1.7761h0.29607v0.29607z","fill":"#fff","stroke":"#fff","strokeLinejoin":"round","strokeWidth":".26458","data-name":"Контур 380092"})));
}

TitleBlockDownArrowSmall.defaultProps = {"width":"4.409mm","height":"2.6329mm","version":"1.1","viewBox":"0 0 4.409 2.6329"};

module.exports = TitleBlockDownArrowSmall;

TitleBlockDownArrowSmall.default = TitleBlockDownArrowSmall;
